// @flow
import React from 'react'
import I18n from 'i18n-react'
import { humanizer } from 'devx-js-utilities'


import { perUnitOfQuality } from '../../ContentFunctions'
import Images from '../../../Themes/Images'

// types
import type { ColumnTypeDefaultProps } from './ColumnTypeDefault'

const ColumnTypeHelpMobile = (props: ColumnTypeDefaultProps) => {
  let showSuriIndex = true
  if (typeof props.quote.suriIndex.show === 'boolean' && !props.quote.suriIndex.show) {
    showSuriIndex = false
  }

  return ([
    props.data.help && props.data.help.usp && Array.isArray(props.data.help.usp) &&
    props.data.help.usp.map((usp) => [
      <span
        className='badge badge-active-object text-dark text-wrap text-lg-nowrap my-1'
        key={`quote-insuranceCompany-help-badge-mobile-${usp}`}
      >
        {I18n.translate(`quoteHelp.${usp}`)}
      </span>,
      <br key={`${usp}-br`} />
    ]),
    props.data.suriIndex && props.data.suriIndex.value && showSuriIndex &&
    <div className='pb-2 pt-3 mt-2 mb-1' key={`quote-insuranceCompany-help-mobile-${props.quote.id}`}>
      <span className='mobile-label w-100 mr-2'>
        <strong className='align-middle mr-2'>{props.data.suriIndex.value}</strong>
        <img alt='Suri index' src={Images.suriIndexImage} width='30'/>
      </span>
      {props.showPerUnitOfQuality && props.showPrice && [
        <strong key='price'>
          {humanizer.csNumber(perUnitOfQuality(props.quote.price, props.data.suriIndex.value))}&nbsp;{I18n.translate('general.currency')}
        </strong>,
        <small key='perUnit'>&nbsp;{I18n.translate('general.perUnitOfQuality')}</small>
      ]}
    </div>
  ])
}

export default ColumnTypeHelpMobile
